<script setup lang="ts">
import { computed } from 'vue';
import ValidationInput from '@/components/ValidationInput.vue';
import { useCsatSuggestionBoxCustomisation } from '../composables/useCsatUserSuggestionsCustomisation';

// Limit from the BE side for CSAT description
const MAX_CSAT_DESCRIPTION_CHAR_NUM = 500;

interface Props {
  value?: string;
}

const props = withDefaults(defineProps<Props>(), {
  value: '',
});

const emit = defineEmits<{
  (event: 'input', value: string): void;
}>();

const {
  placeholderText: placeholderTextValue,
  backgroundColor: textareaBackgroundColor,
  isVisible: isSuggestionBoxVisible,
  placeholderColor: placeholderTextColor,
  borderColor: textareaBorderColor,
} = useCsatSuggestionBoxCustomisation();

const inputCustomisation = computed(() => ({
  backgroundColor: textareaBackgroundColor.value,
  borderColor: textareaBorderColor.value,
  placeholderColor: placeholderTextColor.value,
}));

const handleInput = (value: string) => {
  emit('input', value);
};
</script>

<template>
  <div class="csat-comment-section__wrapper">
    <ValidationInput
      v-if="isSuggestionBoxVisible"
      tag="textarea"
      :value="props.value"
      :placeholder="placeholderTextValue"
      :customisation="inputCustomisation"
      :show-error-text-block="false"
      :max-length="MAX_CSAT_DESCRIPTION_CHAR_NUM"
      class="csat-comment-section__input"
      @input="handleInput"
    />
  </div>
</template>

<style scoped lang="scss">
.csat-comment-section__wrapper {
  margin-bottom: 24px;

  :deep(.validation-input--textarea) {
    min-height: 120px;
  }
}
</style>
